import { AsYouType, CountryCode, format, isValidNumber, parse, parsePhoneNumber, PhoneNumber } from 'libphonenumber-js';
import { isNullOrUndefined } from './is-null-or-defined';

export class PhoneNumberUtil {
  static getCountryCode(phoneNumber: string): CountryCode {
    const parsedPhoneNumber: PhoneNumber = parsePhoneNumber(phoneNumber, 'US');
    if (isNullOrUndefined(parsedPhoneNumber)) {
      return null;
    }

    return parsedPhoneNumber.country;
  }

  static asYouType(phoneNumber: string, countryCode: CountryCode): string {
    return phoneNumber ? new AsYouType(countryCode).input(phoneNumber.toString()) : '';
  }

  static isValidPhoneNumber(phoneNumber: string, countryCode: CountryCode): boolean {
    return isValidNumber(parse(phoneNumber, countryCode));
  }

  static formattedPhoneNumberForRest(phoneNumber: string, countryCode: CountryCode): string {
    return format(parse(phoneNumber, countryCode).phone, countryCode, 'E.164');
  }

  static formattedPhoneNumberForDisplay(phoneNumber: string, countryCode: CountryCode): string {
    return format(parse(phoneNumber, countryCode).phone, countryCode, 'NATIONAL');
  }
}
